<template>
  <base-modal-bottom
    :isFooter="true"
    ref="theModalAccountIsPending"
    title="Transferência indisponível"
  >
    <template #btn-close-icon>
      <i class="icon">
        <base-icon name="painel/close-icon" />
      </i>
    </template>
    <template>
      <div class="modal-paypal-container has-text-centered">
        <div class="columns is-vcentered">
          <div class="column">
            <base-icon width="160" height="120" name="saque-indisponivel" />
          </div>
          <div class="column">
            <p class="margin-bottom">
              <b>
                Infelizmente não será possivel transferir para a sua conta.
              </b>
            </p>
            <p class="margin-bottom">
              Por favor entre em contato com nosso atendimento para maiores
              informações
            </p>
            <base-button-bottom
              @click.native="close"
              type="button"
              class="is-primary is-big"
            >
              Ok, entendi
            </base-button-bottom>
          </div>
        </div>
      </div>
    </template>
  </base-modal-bottom>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'

export default {
  components: {
    BaseModalBottom,
    BaseButtonBottom,
  },

  methods: {
    open() {
      this.$refs.theModalAccountIsPending.open()
    },
    close() {
      this.$refs.theModalAccountIsPending.close()
    },
  },
}
</script>

<style lang="scss">
.modal-paypal-container {
  max-width: 660px;
  margin: 0 auto;
}
</style>
